// TypeScript
import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  mdiAccountBoxOutline,
  mdiAccountCircle,
  mdiAccountOutline,
  mdiAlert,
  mdiAlertCircle,
  mdiAlphaSBoxOutline,
  mdiArrowCollapseLeft,
  mdiArrowCollapseRight,
  mdiBellOutline,
  mdiCalendarExportOutline,
  mdiChevronRight,
  mdiClose,
  mdiCogOutline,
  mdiConnection,
  mdiCreditCardOutline,
  mdiCurrencyEur,
  mdiDeveloperBoard,
  mdiDotsVertical,
  mdiDownload,
  mdiFilter,
  mdiFormatListBulleted,
  mdiInformation,
  mdiInvoiceExportOutline,
  mdiLogout,
  mdiLogoutVariant,
  mdiMapMarkerDistance,
  mdiNumeric,
  mdiOfficeBuildingCogOutline,
  mdiPlus,
  mdiSort,
  mdiTagOutline,
  mdiTrayArrowUp,
  mdiViewDashboardEditOutline,
} from '@mdi/js';

// Custom pictogrammers.com icons used to match the mockups.
@Injectable({ providedIn: 'root' })
export class IconsHandler {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  constructor() {
    this.register('account-box-outline', mdiAccountBoxOutline);
    this.register('account-outline', mdiAccountOutline);
    this.register('account', mdiAccountCircle);
    this.register('alert', mdiAlert);
    this.register('alpha-s-box-outline', mdiAlphaSBoxOutline);
    this.register('arrow-collapse-left', mdiArrowCollapseLeft);
    this.register('arrow-collapse-right', mdiArrowCollapseRight);
    this.register('bell_outline', mdiBellOutline);
    this.register('calendar-export-outline', mdiCalendarExportOutline);
    this.register('chevron-right', mdiChevronRight);
    this.register('close', mdiClose);
    this.register('cog-outline', mdiCogOutline);
    this.register('credit_card_outline', mdiCreditCardOutline);
    this.register('developer_board', mdiDeveloperBoard);
    this.register('dots-vertical', mdiDotsVertical);
    this.register('download', mdiDownload);
    this.register('error', mdiAlertCircle);
    this.register('euro', mdiCurrencyEur);
    this.register('filter', mdiFilter);
    this.register('format-list-bulleted', mdiFormatListBulleted);
    this.register('info', mdiInformation);
    this.register('invoice_export_outline', mdiInvoiceExportOutline);
    this.register('logout', mdiLogout);
    this.register('logout', mdiLogoutVariant);
    this.register('numeric', mdiNumeric);
    this.register('office-building-outline', mdiOfficeBuildingCogOutline);
    this.register('plus', mdiPlus);
    this.register('sort', mdiSort);
    this.register('tag_outline', mdiTagOutline);
    this.register('upload', mdiTrayArrowUp);
    this.register('view_dashboard_edit_outline', mdiViewDashboardEditOutline);
    this.register('connection', mdiConnection);
    this.register('map_marker_distance', mdiMapMarkerDistance);
  }

  private register(name: string, pathData: string) {
    const svg = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="${pathData}"/></svg>`;
    this.iconRegistry.addSvgIconLiteral(name, this.sanitizer.bypassSecurityTrustHtml(svg));
  }
}
